import React from 'react';

type Props = {
  children: React.ReactNode;
};

// Simple AuthProvider that doesn't depend on Azure MSAL
// This is used when OIDC authentication is handled by Authentik
export default function AuthProvider({ children }: Props): JSX.Element {
  return children as JSX.Element;
}
